<div
  fxLayout="column"
  fxLayoutGap="20px"
  class="wrapper"
  style="position: relative"
  appLoginClickGuard
  #commentsElementRef
>
  <div class="fat">{{ comments.length }} {{ comments.length == 1 ? 'Kommentar' : 'Kommentare' }}</div>

  <div *ngIf="comments" fxLayout="column" fxLayoutGap="10px">
    <app-comment *ngFor="let comment of comments; trackBy: trackByFn" [comment]="comment"></app-comment>
  </div>

  <form [formGroup]="form" id="writeComment" #writeComment>
    <div class="tinyheader">Kommentar schreiben</div>
    <div appLoginClickGuard>
      <editor
        apiKey="cirw0hv94c52sgyqp5rseuz1djp09a8nptls2c9a41ypi805"
        [init]="tinyDefaultConfig"
        [formControlName]="'message'"
        (onFocus)="showLogginDialogIfNotLoggedIn()"
      ></editor>
    </div>

    <button class="orange-button mobileGrowBtn" (appLoginClickGuard)="sendComment()">Kommentar absenden</button>
  </form>
</div>
